import { TEquipmentTypesSchema } from 'transfix-form/forms/CarrierFleetInformation/components/EquipmentTypesModal/schema/EquipmentTypesSchema'
import { IUpdateCarrierEquipmentCapabilityInput } from 'types/graphqlTypes'

export const getUpdateCarrierProfileEquipmentInput = ({
  carrierApplicationId,
  formValues,
}: {
  carrierApplicationId: string
  formValues: TEquipmentTypesSchema
}): IUpdateCarrierEquipmentCapabilityInput => {
  const { isDryVanCapable, isFlatbedCapable, isReeferCapable, powerUnitCount, trailerCount } =
    formValues || {}
  return {
    carrierApplicationId,
    powerUnitCount: powerUnitCount || 0,
    trailerCount: trailerCount || 0,
    isReeferCapable,
    isDryVanCapable,
    isFlatbedCapable,
  }
}
